import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDateRangeRequestParams } from "Dashboard/domain/IDateRangeRequestParams";
import { RootState } from "reducers";
import { IStatisticsResponse } from "../domain/IStatisticsResponse";
import { DailyTableService } from "../services/dt.service";

interface dtStatisticsState {
  loading: boolean;
  statistics?: IStatisticsResponse;
  error: any;
};

const initialState: dtStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined
};

export const getStatistics = createAsyncThunk(
  "DailyTable/getStatistics",
  async (data?: IDateRangeRequestParams) => {
    try {
      const result = await DailyTableService.getGeneralStatistics(data);
      return result;
    }
    catch (err) {
      setError(err);
    }
  }
)

export const dtStatisticsSlice = createSlice({
  name: "Charges",
  initialState: initialState,
  reducers: {
    setStatistics: (state, action: PayloadAction<IStatisticsResponse>) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getStatistics.fulfilled,
      (state, action) => {
        state.statistics = action.payload ? action.payload : undefined;
        state.loading = false;
      }
    );
    builder.addCase(
      getStatistics.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) => state.dailytable.statistics;

export const { setError } = dtStatisticsSlice.actions;

export default dtStatisticsSlice.reducer;
